import { BasisOfCoverApi } from 'libs/pinnacle-sdk/apis/BasisOfCoverApi';
import { SubLimitsApi } from 'libs/pinnacle-sdk/apis/SubLimitsApi';
import {
  BrokerApi,
  Configuration,
  ReferenceDataApi,
  CountryStateCityApi,
  InsuredApi,
  SubmissionApi,
  UploadedFileApi,
  StorageApi,
  Middleware,
  UserApi,
  LayerApi,
  SubLimitSettingsApi,
  ScheduleOfValuesApi,
  LayerResultsApi,
  BinderApi,
  ReinsuredApi,
  ContractApi,
  ReviewNoteApi,
  PremiumScheduleApi,
  ReceiptApi,
  ClaimsApi,
  CatEventApi,
  CurrencyApi,
  BinderClaimApi,
  ClaimMasterReserveApi,
  ClaimPaymentsApi,
} from 'libs/pinnacle-sdk';
import { getLatestToken } from 'services/auth';
import { PriceRatingApi } from './price-rating-api';

const tokenMiddleware: Middleware = {
  pre: async (context) => {
    const token = await getLatestToken();
    if (token) {
      context.init.headers = {
        ...context.init.headers,
        Authorization: `Bearer ${token.accessToken}`,
      };
    }
    return context;
  },
};

const basePath = process.env.REACT_APP_PINNACLE_API_BASE_URL;

const pinnacleConfig = new Configuration({
  basePath,
  middleware: [tokenMiddleware],
});

export const submissionApi = new SubmissionApi(pinnacleConfig);

export const claimsApi = new ClaimsApi(pinnacleConfig);

export const claimMasterReserveApi = new ClaimMasterReserveApi(pinnacleConfig);

export const brokerApi = new BrokerApi(pinnacleConfig);

export const insuredApi = new InsuredApi(pinnacleConfig);

export const catEventApi = new CatEventApi(pinnacleConfig);

export const countryStateCityApi = new CountryStateCityApi(pinnacleConfig);

export const referenceDataApi = new ReferenceDataApi(pinnacleConfig);

export const uploadedFileApi = new UploadedFileApi(pinnacleConfig);

export const storageApi = new StorageApi(pinnacleConfig);

export const userApi = new UserApi(pinnacleConfig);

export const layerApi = new LayerApi(pinnacleConfig);

export const subLimitSettingsApi = new SubLimitSettingsApi(pinnacleConfig);

export const subLimitsApi = new SubLimitsApi(pinnacleConfig);

export const basisOfCoverApi = new BasisOfCoverApi(pinnacleConfig);

export const sovFileStatusSseUrl = (fileId: string) =>
  `${basePath}/schedule-of-values/process/${fileId}`;

export const scheduleOfValuesApi = new ScheduleOfValuesApi(pinnacleConfig);

export const priceRatingApi = new PriceRatingApi();

export const layerResultApi = new LayerResultsApi(pinnacleConfig);

export const binderApi = new BinderApi(pinnacleConfig);

const url = new URL(basePath as string);
const baseUrl = `${url.protocol}//${url.host}`;
export const priceRatingGatewayUrl = `${baseUrl}/price-rating-gateway`;

export const reinsuredApi = new ReinsuredApi(pinnacleConfig);

export const contractApi = new ContractApi(pinnacleConfig);

export const reviewNoteApi = new ReviewNoteApi(pinnacleConfig);

export const premiumScheduleApi = new PremiumScheduleApi(pinnacleConfig);

export const receiptApi = new ReceiptApi(pinnacleConfig);

export const currencyApi = new CurrencyApi(pinnacleConfig);

export const binderClaimApi = new BinderClaimApi(pinnacleConfig);

export const claimPaymentsApi = new ClaimPaymentsApi(pinnacleConfig);
